@if (accessPinCloseButton()) {
  <button class="access-pin-close-button" type="button" (click)="dismissModal('cancel')">
    <ion-icon name="close-outline"></ion-icon>
  </button>
}

@if (showHeader() || dynamicHeaderTemplate()) {
  <ion-header [class.ion-no-border]="!headerWithShadow() || !showHeader()">
    <ng-container
      *ngTemplateOutlet="dynamicHeaderTemplate() ? dynamicHeaderTemplate() : defaultHeader;">
    </ng-container>
    </ion-header>
}

<ng-template #defaultHeader>
  @if(showHeader() || showCloseButton()) {
    <ion-toolbar>
      @if (showHeader() && header()) {
        <ion-title [class.ion-text-center]="centerHeaderTitle()">
          <h3 class="ion-no-margin">{{ header() | translate }}</h3>
        </ion-title>
      }
      @if (showCloseButton()) {
        <ion-buttons slot="end">
          <ion-button fill="clear" color="dark" size="large" (click)="dismissModal('cancel')" aria-label="Close">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      }
    </ion-toolbar>
  }
</ng-template>

<ion-content [scrollY]="!centerInnerContent()" [fullscreen]="true" [class.ion-padding]="!centerInnerContent()">
  @if (centerInnerContent()) {
    <ion-grid class="ion-no-padding" style="height: 100%">
      <ion-row class="ion-justify-content-center ion-align-items-center" style="height: 100%">
        <ion-col size="12" size-sm="10" size-md="8" size-lg="6" class="ion-text-center ion-padding">
          @if (message() && !config().innerComponent) {
             <p>{{ message() | translate }}</p>
          }
          <ng-template dynamicHost></ng-template>
        </ion-col>
      </ion-row>
    </ion-grid>
  } @else {
     @if (message() && !config().innerComponent) {
        <p class="ion-padding-start ion-padding-end">{{ message() | translate }}</p>
     }
    <ng-template dynamicHost></ng-template>
  }
</ion-content>

@if (showFooter() || dynamicFooterTemplate()) {
  <ion-footer [class.ion-no-border]="!showFooterShadow()">
    <ng-container
      *ngTemplateOutlet="dynamicFooterTemplate() ? dynamicFooterTemplate() : defaultFooter;">
    </ng-container>
    </ion-footer>
}

<ng-template #defaultFooter>
   @if(showFooter()) {
    <ion-toolbar>
      <ion-grid class="ion-justify-content-center ion-align-items-center ion-no-padding">
        <ion-row class="ion-justify-content-center ion-padding-vertical">
          <ion-col [size]="footerColumeSize()">
            @if (showFooterButton()) {
              <ion-button
                class="ion-padding-horizontal"
                [color]="footerButtonColor()"
                (click)="executeFooterAction()"
                [expand]="footerButtonExpandMode() ? footerButtonExpandMode() : undefined"
                [disabled]="footerButtonDisabled()"
              >
                {{ footerButtonText() | translate }}
              </ion-button>
            }
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-toolbar>
  }
</ng-template>
